import React, {useState} from 'react'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid' // Generate unique IDs for the events dinamically added directly from the web app.
import { clearFields } from '../helpers/functions'
import Switch from 'react-input-switch'

const FormStyled = styled.form`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: white;
  padding: 0 0.8rem;
  width:150px;
  box-shadow: -4px 8px 12px rgba(0,0,0,0.15);
`
const CloseForm = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 40px;
  height: 20px;
`
  const AddEventButton = styled.button`
    background-color: white;
    color: #192A3E;
    box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
    border: 1px solid #E5E5E5;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-radius: 1rem;
    transition: all 0.4;
    outline: none;
    &:hover {
      box-shadow: 0px 4px 8px rgba(0,0,0,0.25);
      transform: translateY(-2px) scale(1) translateX(-0px);
    }
    &:active {
      box-shadow: 0px 1px 5px 0px rgba(130,130,130,1); 
      transform: translateY(-1px) scale(1);
    }
  `

export default function Form(props) {
  const [newEventName, setNewEventName] = useState('')
  const [newEventLocation, setNewEventLocation] = useState('')
  const [newEventStart, setNewEventStart] = useState('0900')
  const [newEventEnd, setNewEventEnd] = useState('0930')
  const [allDayCheckbox, setAllDayCheckbox] = useState(0) // 0 stands for false, 1 stands for true (as per the react-input-switch specs)

  function handleSubmit(event) {
    event.preventDefault()
    if (newEventStart >= newEventEnd && allDayCheckbox === 0) {
      alert('Please make sure that END is greater than START')
      clearFields(setNewEventEnd, setNewEventStart, setNewEventLocation, setNewEventName, setAllDayCheckbox)
      props.setShowForm(false)
      return
    }
    if (newEventName.length < 1) {
      alert('Please specify a name for your event')
      clearFields(setNewEventEnd, setNewEventStart, setNewEventLocation, setNewEventName, setAllDayCheckbox)
      props.setShowForm(false)
      return
    }
    const newEvent = {
      "name": newEventName,
      "location": newEventLocation,
      "start": newEventStart,
      "end": newEventEnd,
      "allday": newEventStart && newEventEnd ? false : true,
      "uniqueID": uuidv4()
    }
    props.setDb(prevDatabase => {
      // see if day already exists. If it doesn't, create a new day object with an "events" array as one of its properties.
      const copyofdb = [...prevDatabase]
      const match = copyofdb.find(el => el.day === props.today)
      if (match) {
          match.events = [...match.events, newEvent]
      } else {
        const newDayWithEvents = {
          "day": props.today,
          events: [newEvent]
        }
        copyofdb.push(newDayWithEvents)
      }
      return copyofdb
    })
    clearFields(setNewEventEnd, setNewEventStart, setNewEventLocation, setNewEventName, setAllDayCheckbox)
    props.setShowForm(false)
  }

  // If showForm is set to false, render an "Add Event" button.
  if (!props.showForm) {
    return (
      <AddEventButton onClick={(e) => {
        // Stop the propagation of the click event, so the parent won't register the click and fire the setShowForm(false) setter. Repeat for the FormStyled div.
        e.stopPropagation()
        props.setShowForm(true)
      }}>Add Event</AddEventButton>
    )
  }

  return (
    <FormStyled onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <CloseForm onClick={() => props.setShowForm(false)}>X</CloseForm>
        <label>
          Event
          <input autoFocus type="text" value={newEventName} onChange={(e) => setNewEventName(e.target.value)} />
        </label>
        <label>
          Location
          <input type="text" value={newEventLocation} onChange={(e) => setNewEventLocation(e.target.value)} />
        </label>
        <label>
          Start
          <select value={newEventStart} disabled={allDayCheckbox} onChange={(e) => setNewEventStart(e.target.value)}>
            <option value="0000" className='AM'>12:00 AM</option>
            <option value="0030" className='AM'>12:30 AM</option>
            <option value="0100" className='AM'>01:00 AM</option>
            <option value="0130" className='AM'>01:30 AM</option>
            <option value="0200" className='AM'>02:00 AM</option>
            <option value="0230" className='AM'>02:30 AM</option>
            <option value="0300" className='AM'>03:00 AM</option>
            <option value="0330" className='AM'>03:30 AM</option>
            <option value="0400" className='AM'>04:00 AM</option>
            <option value="0430" className='AM'>04:30 AM</option>
            <option value="0500" className='AM'>05:00 AM</option>
            <option value="0530" className='AM'>05:30 AM</option>
            <option value="0600" className='AM'>06:00 AM</option>
            <option value="0630" className='AM'>06:30 AM</option>
            <option value="0700" className='AM'>07:00 AM</option>
            <option value="0730" className='AM'>07:30 AM</option>
            <option value="0800" className='AM'>08:00 AM</option>
            <option value="0830" className='AM'>08:30 AM</option>
            <option value="0900" className='AM'>09:00 AM</option>
            <option value="0930" className='AM'>09:30 AM</option>
            <option value="1000" className='AM'>10:00 AM</option>
            <option value="1030" className='AM'>10:30 AM</option>
            <option value="1100" className='AM'>11:00 AM</option>
            <option value="1130" className='AM'>11:30 AM</option>
            <option value="1200" className='PM'>12:00 PM</option>
            <option value="1230" className='PM'>12:30 PM</option>
            <option value="1300" className='PM'>01:00 PM</option>
            <option value="1330" className='PM'>01:30 PM</option>
            <option value="1400" className='PM'>02:00 PM</option>
            <option value="1430" className='PM'>02:30 PM</option>
            <option value="1500" className='PM'>03:00 PM</option>
            <option value="1530" className='PM'>03:30 PM</option>
            <option value="1600" className='PM'>04:00 PM</option>
            <option value="1630" className='PM'>04:30 PM</option>
            <option value="1700" className='PM'>05:00 PM</option>
            <option value="1730" className='PM'>05:30 PM</option>
            <option value="1800" className='PM'>06:00 PM</option>
            <option value="1830" className='PM'>06:30 PM</option>
            <option value="1900" className='PM'>07:00 PM</option>
            <option value="1930" className='PM'>07:30 PM</option>
            <option value="2000" className='PM'>08:00 PM</option>
            <option value="2030" className='PM'>08:30 PM</option>
            <option value="2100" className='PM'>09:00 PM</option>
            <option value="2130" className='PM'>09:30 PM</option>
            <option value="2200" className='PM'>10:00 PM</option>
            <option value="2230" className='PM'>10:30 PM</option>
            <option value="2300" className='PM'>11:00 PM</option>
            <option value="2330" className='PM'>11:30 PM</option>
          </select>
        </label>
        <label>
          End
          <select value={newEventEnd} disabled={allDayCheckbox} onChange={(e) => setNewEventEnd(e.target.value)}>
            <option value="0030" className='AM'>12:30 AM</option>
            <option value="0100" className='AM'>01:00 AM</option>
            <option value="0130" className='AM'>01:30 AM</option>
            <option value="0200" className='AM'>02:00 AM</option>
            <option value="0230" className='AM'>02:30 AM</option>
            <option value="0300" className='AM'>03:00 AM</option>
            <option value="0330" className='AM'>03:30 AM</option>
            <option value="0400" className='AM'>04:00 AM</option>
            <option value="0430" className='AM'>04:30 AM</option>
            <option value="0500" className='AM'>05:00 AM</option>
            <option value="0530" className='AM'>05:30 AM</option>
            <option value="0600" className='AM'>06:00 AM</option>
            <option value="0630" className='AM'>06:30 AM</option>
            <option value="0700" className='AM'>07:00 AM</option>
            <option value="0730" className='AM'>07:30 AM</option>
            <option value="0800" className='AM'>08:00 AM</option>
            <option value="0830" className='AM'>08:30 AM</option>
            <option value="0900" className='AM'>09:00 AM</option>
            <option value="0930" className='AM'>09:30 AM</option>
            <option value="1000" className='AM'>10:00 AM</option>
            <option value="1030" className='AM'>10:30 AM</option>
            <option value="1100" className='AM'>11:00 AM</option>
            <option value="1130" className='AM'>11:30 AM</option>
            <option value="1200" className='PM'>12:00 PM</option>
            <option value="1230" className='PM'>12:30 PM</option>
            <option value="1300" className='PM'>01:00 PM</option>
            <option value="1330" className='PM'>01:30 PM</option>
            <option value="1400" className='PM'>02:00 PM</option>
            <option value="1430" className='PM'>02:30 PM</option>
            <option value="1500" className='PM'>03:00 PM</option>
            <option value="1530" className='PM'>03:30 PM</option>
            <option value="1600" className='PM'>04:00 PM</option>
            <option value="1630" className='PM'>04:30 PM</option>
            <option value="1700" className='PM'>05:00 PM</option>
            <option value="1730" className='PM'>05:30 PM</option>
            <option value="1800" className='PM'>06:00 PM</option>
            <option value="1830" className='PM'>06:30 PM</option>
            <option value="1900" className='PM'>07:00 PM</option>
            <option value="1930" className='PM'>07:30 PM</option>
            <option value="2000" className='PM'>08:00 PM</option>
            <option value="2030" className='PM'>08:30 PM</option>
            <option value="2100" className='PM'>09:00 PM</option>
            <option value="2130" className='PM'>09:30 PM</option>
            <option value="2200" className='PM'>10:00 PM</option>
            <option value="2230" className='PM'>10:30 PM</option>
            <option value="2300" className='PM'>11:00 PM</option>
            <option value="2330" className='PM'>11:30 PM</option>
            <option value="2400" className='PM'>00:00</option>
          </select>
        </label>
        <label>
          All Day &nbsp;
          <Switch value={allDayCheckbox} 
            onChange={(e) => {
              setAllDayCheckbox(e)
              setNewEventStart(null)
              setNewEventEnd(null)
            }}  
          />
        </label>
        <input type="submit" value="Submit"/>
      </FormStyled>
  )
}
